import React, { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

// styles
const StyledAccordionPanel = styled.div<{ isHeaderClickable: boolean }>`
    border: 2px solid #ccc;
    border-radius: 7px;

    .header-container {
        display: flex;
        border-radius: 5px;
    }

    .header {
        padding: 0 1% 0 1%;
        width: 100%;
        align-items: center;
    }

    .header-content {
        width: 100%;
        cursor: ${({ isHeaderClickable }) => (isHeaderClickable ? 'pointer' : 'default')};
        background: none;
        border: none;
        font-weight: normal;
        text-align: left;
        display: flex;
    }

    .header-text {
        width: 100%;
        padding:5px;
    }

    .content {
        border-top: 2px solid #ccc;
    }

    .toggle-icon {
        align-self: center;
        outline: none;
    }
    
`;

// props
export interface AccordionPanelProps {
    id: string;
    onToggle?(isExpanded: boolean): void;
    isExpandable?: boolean;
    isInitialExpanded?: boolean;
    isLeftToggle?: boolean;
    expandedIcon?: IconProp;
    collapsedIcon?: IconProp;
    header: React.ReactNode;
    children: React.ReactNode;
    isHeaderClickable?: boolean;
    ariaControlsId: string;
}

const AccordionPanel = ({
    id,
    ariaControlsId,
    isInitialExpanded = false,
    isExpandable = true,
    isLeftToggle = false,
    collapsedIcon = 'chevron-down',
    expandedIcon = 'chevron-up',
    header,
    children,
    onToggle: onToggleFromProp,
    isHeaderClickable = true,
}: AccordionPanelProps) => {
    const [expanded, setExpanded] = useState(isInitialExpanded);
    const HeaderComponent = header;

    const onToggle = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setExpanded(!expanded);
        onToggleFromProp && onToggleFromProp(expanded);
    };

    return (
        <StyledAccordionPanel className="accordion-panel-component" isHeaderClickable={isHeaderClickable}>
            <div className="header-container">
                <div className="header">
                    <button
                        className="header-content"
                        id={id}
                        aria-controls={isExpandable ? ariaControlsId : undefined}
                        aria-expanded={isExpandable ? expanded : undefined}
                        onClick={e => {
                            if (!isHeaderClickable || !isExpandable) return;
                            onToggle(e);
                        }}
                    >
                        {isLeftToggle && isExpandable ? (
                            <div className="toggle-icon">
                                <FontAwesomeIcon
                                    icon={expanded ? expandedIcon : collapsedIcon}
                                    className="grid-col-1"
                                />
                            </div>
                        ) : null}

                        <div className="header-text">{HeaderComponent}</div>

                        {isLeftToggle === false && isExpandable ? (
                            <div className="toggle-icon">
                                <FontAwesomeIcon
                                    icon={expanded ? expandedIcon : collapsedIcon}
                                    className="grid-col-1 icon"
                                />
                            </div>
                        ) : null}
                    </button>
                </div>
            </div>
            {expanded && (
                <div className="content" aria-labelledby={id} role="region" id={ariaControlsId}>
                    {children}
                </div>
            )}
        </StyledAccordionPanel>
    );
};

export default AccordionPanel;
